import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import ClaimAnalysisPageConstants from '../../core-utils/messages/recommendationsTabMessages';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import ScrollDown from '../../_components/atoms/ScrollDown';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';

export interface ClaimAnalysisPageProps {}

export const pageScrollDown = (elementId: string) => {
  const handleClickScrollDown = () => {
    const element = document.getElementById(elementId);
    if (element) {
      // 👇 Will scroll smoothly to the top of the given element id section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        right: 0,
        bottom: 0,
        padding: '0px 16px 16px 0px',
      }}
    >
      <ScrollDown onClick={() => handleClickScrollDown()} showPageDown={true} />
    </div>
  );
};

const ClaimAnalysisPage: React.FC<ClaimAnalysisPageProps> = observer(({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
  });

  const { classes } = useStyles();

  const messages = ClaimAnalysisPageConstants;

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );

  //snackbar

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const recommendedTabStore = useStores().recommendedTabStore;
  const employerGroupStore = useStores().employerGroupStore;

  const getRecommendations = () => {
    getRecommendationsData(
      employerGroupStore?.employerGroupResponseData?.eg_nid,
      '',
      recommendedTabStore,
      setRecommendationLoading,
    );
  };

  useEffect(() => {
    getRecommendations();
  }, []);
  return (
    <>
      <div>
        <Grid container className={classes.root}>
          <Grid
            style={{
              marginBottom: '36px',
              width: '1182px',
              position: 'relative',
            }}
          >
            <PageTitleAndSubTitle
              title={messages.title}
              subTitle={messages.SubTitle}
              showDownloadButton={false}
              showQueryDataButton={false}
              subTitleStyles={{ width: '1186px' }}
            />
          </Grid>

          <Grid>
            <RecommendationsTab recommendationLoading={recommendationLoading} />
          </Grid>

          <div id="scroll-top-element"></div>
        </Grid>
        {pageScrollDown('scroll-top-element')}
      </div>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default ClaimAnalysisPage;
